import './UniWidgetDobleColumnReport.scss';
import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';

export type UniWidgetDobleColumnReportProps = {
    options: UniWidgetDobleColumnReportOptions[][],
    filterOptions: UniWidgetDobleColumnReportOptions[],
    columnReportWidth: number,
    columnReportHeight: number,
    maxValue?: number
};

export type UniWidgetDobleColumnReportOptions = {
    value: number,
    description: string,
    color?: string
}

const UniWidgetDobleColumnReport = (props: UniWidgetDobleColumnReportProps) => {
    return (
        <>
            <div className='uni-widget-double-column-report'>
                {
                    <>
                        <div className='d-flex justify-content-between column-report-header'>
                            <div className='filter-select d-flex gap-3'>
                                {props?.filterOptions?.map(op => (
                                    <p className='d-flex align-items-center gap-2'><p className='icon-legend' style={{backgroundColor: op.color}}></p>{op.description}</p>
                                ))}
                            </div>
                        </div>
                        <div className='d-flex justify-content-left items-graph-wrapper'>
                            <div className='items'>
                            {
                                props.options?.map((option, idx) => {
                                    return (
                                        <div className='d-flex flex-column' key={idx}>
                                            <div className='d-flex'>
                                                {
                                                    option?.map((item, x) => (
                                                        <div key={x} style={(x + 1) % 2 == 0 ? {marginRight: 50, width: props.columnReportWidth + 'px', height: props.columnReportHeight + 'px'} : {width: props.columnReportWidth + 'px', height: props.columnReportHeight + 'px'}} className='item-graph-wrapper'>
                                                            <p className='value'>
                                                                {item?.value > 0 ? item.value : '0'}
                                                            </p>
                                                            <div
                                                                className='item-graph'
                                                                style={{
                                                                    height: (item.value > 0 ? ((item?.value / (props.maxValue ?? 1)) * props.columnReportHeight) : 1) + 'px',
                                                                    maxHeight: props.columnReportHeight + 'px',
                                                                    backgroundColor: item?.color ? item.color : (idx & 1 ? '#02FF3E' : '#0F8A38')
                                                                }}
                                                                >
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        <p key={idx} className="description"> {props.options[idx]?.[0]?.description}</p>
                                        </div>
                                    )
                                })
                            }
                            </div>
                            {/* <div className='columns'>
                            {
                                props.options?.map((option, idx) => {
                                    return option?.map((item, x) => {
                                        if ((x + 1) % 2 == 0) {
                                            return (<></>)
                                        }

                                        return (
                                            <p key={idx} className="description" style={{ width: (props.columnReportWidth * 2) + 35 + 'px' }}> {item.description}</p>
                                        )
                                    })
                                })
                            }
                            </div> */}
                        </div>
                    </>
                }
            </div>
        </>
    )
}

export default UniWidgetDobleColumnReport;